import './App.css';
import React from "react";
import routes from "./routes";
import {
  Routes, Route,
} from 'react-router-dom';
import makeStyles from "@mui/styles/makeStyles";

let vh = window.innerHeight * 0.01;

const useStyles = makeStyles({
  app: {
      ['@media (max-width: 640px)']: {
        height: 100*vh,
        minWidth: '100vw',
      },
      ['@media (min-width: 640px)']: {
          width: '640px',
          minHeight: '720px',
          marginTop: '20px',
          marginBottom: '40px',
          // border: "px solid #000000",
          boxSizing: "border-box",
          borderRadius: '20px',
          boxShadow: '5px 5px 5px 5px rgb(0 0 0 / 0.2)',
      }
  }
});

function App() {
    const classes = useStyles();
    return (
      <div className={"App" + " " + classes.app} style={{align: 'center'}}>
        <Routes>
            {routes.map(({ path, component }) => (
                <Route exact path={path} element={component}/>
              ))}
        </Routes>
      </div>
    );
}

export default App;